<app-toolbar></app-toolbar>

<div class="row"
     style="text-align: right;">
  <a routerLink="adicionar">
    <img class="imgAdicionar"
         src="../../../assets/icones/adicionar.svg">
  </a>
</div>

<div class="row"
     style="justify-content: center;align-items: center;display: flex;">
  <div class="col s12 m12 l12 card-block">
    <div class="row">
      <div class="col cardDiv"
           *ngFor="let unidade of unidades">
        <div class="card">
          <div class="linha">
            <div class="imgDiv">
              <img class="responsive-img"
                   [src]="unidade.image?.url || 'assets/images/nophoto.png'">
            </div>
            <div>
              <div class="div-dados">
                <span class="card-title">
                  {{unidade.name}}
                </span>
                <br>
                <span class="titleItalic">
                  {{unidade.city}} - {{unidade.area}}
                </span>
                <br>
                <span class="titleItalic">
                  {{unidade.is_stopped ? "Vendas Pausadas": "Vendas Ativas" }}
                </span>
              </div>
              <div class="divBotoes">
                <a class="botoes"
                   (click)="estoque(unidade._id)">
                  <img class="imgIcones"
                       src="../../../assets/icones/estoque.svg"
                       [title]="translatePipe.transform('estoque')">
                </a>
                <a class="botoes"
                   (click)="editar(unidade._id)">
                  <img class="imgIcones"
                       src="../../../assets/icones/editar.svg"
                       [title]="translatePipe.transform('texto_editar')">
                </a>
                <a class="botoes"
                   (click)="excluirUnidade(unidade._id)">
                  <img class="imgIcones"
                       src="../../../assets/icones/excluir.svg"
                       [title]="translatePipe.transform('texto_excluir')">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>